import {
  getStickerTransactions,
  getStripeTransactions,
  getBenevityTransactions,
  getBenevityW2WCreditTransactions,
} from '@/graphs/activity';
import { makeRequest } from '@/graphs/index';

const actions = {
  SET_SORT({ commit }, value) {
    commit('MUTATE_SORT', value);
  },
  SET_DATE({ commit }, value) {
    commit('MUTATE_DATE', value);
  },
  SET_SEARCH({ commit }, value) {
    commit('MUTATE_SEARCH', value);
  },
  SET_CURRENT_TAB({ commit, dispatch }, value) {
    commit('MUTATE_CURRENT_TAB', value);
    // Fetch data for the new tab
    dispatch('FETCH_CURRENT_TAB_DATA');
  },
  async FETCH_STICKER_TRANSACTIONS({ commit, rootGetters }, {
    entity = null, entityId = null, fromDate = null, toDate = null,
  }) {
    commit('MUTATE_STICKER_LOADING', true);
    commit('MUTATE_STICKER_ERROR', false);

    const token = rootGetters['users/getToken'];
    const variables = {
      entity,
      entityId,
      fromDate,
      toDate,
    };

    try {
      const response = await makeRequest('query', getStickerTransactions, variables, { token });
      if (response.errors?.length) {
        throw new Error('There has been an error');
      }
      commit('MUTATE_STICKER_TRANSACTIONS', response.data.GetStickerTransactionsForActivity);
      commit('MUTATE_STICKER_LOADING', false);
      commit('MUTATE_STICKER_ERROR', false);
      return true;
    } catch (e) {
      commit('MUTATE_STICKER_ERROR', e);
      commit('MUTATE_STICKER_LOADING', false);
      return false;
    }
  },

  async FETCH_STRIPE_TRANSACTIONS({ commit, rootGetters }, {
    entity = null, entityId = null, fromDate = null, toDate = null,
  }) {
    commit('MUTATE_STRIPE_LOADING', true);
    commit('MUTATE_STRIPE_ERROR', false);

    const token = rootGetters['users/getToken'];
    const variables = {
      entity,
      entityId,
      fromDate,
      toDate,
    };

    try {
      const response = await makeRequest('query', getStripeTransactions, variables, { token });
      if (response.errors?.length) {
        throw new Error('There has been an error');
      }
      commit('MUTATE_STRIPE_TRANSACTIONS', response.data.GetStripeTransactionsForActivity);
      commit('MUTATE_STRIPE_LOADING', false);
      commit('MUTATE_STRIPE_ERROR', false);
      return true;
    } catch (e) {
      commit('MUTATE_STRIPE_ERROR', e);
      commit('MUTATE_STRIPE_LOADING', false);
      return false;
    }
  },

  async FETCH_BENEVITY_TRANSACTIONS({ commit, rootGetters }, {
    entity = null, entityId = null, fromDate = null, toDate = null,
  }) {
    commit('MUTATE_BENEVITY_LOADING', true);
    commit('MUTATE_BENEVITY_ERROR', false);

    const token = rootGetters['users/getToken'];
    const variables = {
      entity,
      entityId,
      fromDate,
      toDate,
    };

    try {
      const response = await makeRequest('query', getBenevityTransactions, variables, { token });
      if (response.errors?.length) {
        throw new Error('There has been an error');
      }
      commit('MUTATE_BENEVITY_TRANSACTIONS', response.data.GetBenevityTransactionsForActivity);
      commit('MUTATE_BENEVITY_LOADING', false);
      commit('MUTATE_BENEVITY_ERROR', false);
      return true;
    } catch (e) {
      commit('MUTATE_BENEVITY_ERROR', e);
      commit('MUTATE_BENEVITY_LOADING', false);
      return false;
    }
  },

  async FETCH_BENEVITY_W2W_TRANSACTIONS({ commit, rootGetters }, {
    entity = null, entityId = null, fromDate = null, toDate = null,
  }) {
    commit('MUTATE_BENEVITY_W2W_LOADING', true);
    commit('MUTATE_BENEVITY_W2W_ERROR', false);

    const token = rootGetters['users/getToken'];
    const variables = {
      entity,
      entityId,
      fromDate,
      toDate,
    };

    try {
      const response = await makeRequest('query', getBenevityW2WCreditTransactions, variables, { token });
      if (response.errors?.length) {
        throw new Error('There has been an error');
      }
      commit('MUTATE_BENEVITY_W2W_TRANSACTIONS', response.data.GetBenevityW2WCreditTransactionsForActivity);
      commit('MUTATE_BENEVITY_W2W_LOADING', false);
      commit('MUTATE_BENEVITY_W2W_ERROR', false);
      return true;
    } catch (e) {
      commit('MUTATE_BENEVITY_W2W_ERROR', e);
      commit('MUTATE_BENEVITY_W2W_LOADING', false);
      return false;
    }
  },

  async FETCH_CURRENT_TAB_DATA({ dispatch, getters, rootGetters }) {
    const currentTab = getters.GET_CURRENT_TAB;
    const dateRange = getters.GET_DATE;
    const isOrgAdmin = rootGetters['users/isOrgAdmin'];

    let entity = null;
    let entityId = null;

    if (isOrgAdmin) {
      const selectedOrg = rootGetters['organizations/GET_SELECTED_ORGANIZATION'];
      if (selectedOrg && selectedOrg.id) {
        entity = 'Organization';
        entityId = selectedOrg.id;
      }
    }

    // Process date range with validation
    let fromDate = null;
    let toDate = null;

    if (dateRange && Array.isArray(dateRange) && dateRange.length === 2) {
      const [startDate, endDate] = dateRange.map((d) => new Date(d));

      fromDate = startDate.toISOString();
      toDate = endDate.toISOString();
    } else {
      // Default to last 30 days if no date range is set
      const endDate = new Date();
      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 30);

      fromDate = startDate.toISOString();
      toDate = endDate.toISOString();
    }

    const params = {
      entity,
      entityId,
      fromDate,
      toDate,
    };

    switch (currentTab) {
      case 'sticker':
        return await dispatch('FETCH_STICKER_TRANSACTIONS', params);
      case 'stripe':
        return await dispatch('FETCH_STRIPE_TRANSACTIONS', params);
      case 'benevity':
        return await dispatch('FETCH_BENEVITY_TRANSACTIONS', params);
      case 'benevity-w2w':
        return await dispatch('FETCH_BENEVITY_W2W_TRANSACTIONS', params);
      default:
        return await dispatch('FETCH_STICKER_TRANSACTIONS', params);
    }
  },

  async SET_SELECTED_LOGS({ commit }, value) {
    commit('MUTATE_SELECTED_LOGS', value);
  },
};

export default actions;
